import classNames from 'classnames'
import { endOfMonth, startOfMonth } from 'date-fns'

import { RedGreenText } from '../../../../components/RedGreenText'
import { shortFormatDollar } from '../../../../util'
import { BarType } from './constants'
import { VolumeChartDataPerTimeframe } from './types'

export function tooltipTitleFormatter(date: number) {
  const startDate = startOfMonth(date)
  const endDate = endOfMonth(startDate)

  const month = startDate.toLocaleString('en-US', { month: 'short' })
  const startDay = startDate.getDate()
  const year = startDate.getFullYear()
  const endDay = endDate.getDate()
  return `${month} ${startDay}-${endDay}, ${year}`
}

export function tooltipDataFormatter(
  _: unknown,
  {
    dataKey,
    fullTooltipPayload,
  }: { dataKey: string; fullTooltipPayload: { payload?: { insider: VolumeChartDataPerTimeframe } }[] }
) {
  const { insider } = fullTooltipPayload[0]?.payload ?? {}

  if (!insider) return null

  const tradeCount = dataKey === BarType.Buy ? insider?.buyTransactionCount : insider?.saleTransactionCount
  const value = dataKey === BarType.Buy ? insider?.buyAggregated : insider?.saleAggregated
  const isZeroValue = value === 0
  const valueToUse = isZeroValue ? null : dataKey === BarType.Buy ? value : -value

  return (
    <RedGreenText
      // use null to get gray color on zero values
      value={valueToUse}
      rightContent={null}
      className={classNames('col-end-3 grid grid-cols-subgrid', {
        'col-start-3': isZeroValue,
        'col-start-1': !isZeroValue,
      })}
    >
      <span className="ml-1">{shortFormatDollar(isZeroValue ? null : value, { defaultValue: '—' })} </span>
      {!isZeroValue && (
        <span className="ml-1 text-left">
          ({tradeCount ?? 0} Trade{tradeCount === 1 ? '' : 's'})
        </span>
      )}
    </RedGreenText>
  )
}
